var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4019 4.5C13.5566 2.5 16.4434 2.5 17.5981 4.5L25.3923 18C26.547 20 25.1036 22.5 22.7942 22.5H7.20577C4.89637 22.5 3.45299 20 4.6077 18L12.4019 4.5Z",
    fill: "#E2D138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4536 11.6379C16.1502 14.0473 15.814 16.0345 15.025 16.0345C14.236 16.0345 14.0187 14.049 13.5963 11.6379C13.0249 8.37599 14.236 7.24139 15.025 7.24139C15.814 7.24139 16.8821 8.23416 16.4536 11.6379Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0001,
    cy: 18.1035,
    rx: 1.03448,
    ry: 1.03448,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.51c215fe136cd057674671ed86cff570.svg";
export { ForwardRef as ReactComponent };